import { Box, Grid } from "@mui/material";
import { clearOpenSections } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import PageTitle from "components/common/PageTitle";
import Typography from "components/common/Typography";
import SearchAppBar from "components/common/searchBar";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DEFAULT_CORP_INNCODE, PAGE_SIZE, messages } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import AbovePropertyList from "./AboveProperty";
import CreateMyPlan from "./Create";
import Filters from "./Filters";
import List from "./list";
import { fetchMyPlansAsync } from "./myplans.slice";

const Index = () => {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const searchText = useAppSelector((state) => state.app.searchText);
  const [inputText, setInputText] = useState(searchText);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const innCode = useAppSelector((state) => state.app.innCode);
  const isSmeUser = useAppSelector((state) => state.app.isSmeUser);
  const { isAbovePropertyUser }: any = useAppSelector((state) => state.app);
  const status = useAppSelector((state) => state.formDetails.addToMyPlans.status);
  const initialBookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const selectedAdminInncodes = useAppSelector((state) => state.myplans.MyPlans.selectedAdminInncodes);
  const {
    selectedFunctionalAreas,
    selectedInncodes,
    selectedBrand,
    selectedStatus,
    selectedUser,
    selectedPlanSources
  } = useAppSelector((state) => state.app);
  const innCodes = () => {
    if (innCode === DEFAULT_CORP_INNCODE) {
      return selectedAdminInncodes?.length > 0
        ? selectedAdminInncodes?.map((item: any) => item?.innCode).join(",")
        : initialBookMarkInncodes?.map((item: any) => item?.innCode).join(",");
    } else {
      return innCode;
    }
  };
  const [filters, setFilters] = useState({
    innCode: isAdmin ? innCodes() : selectedInncodes.join(","),
    functionalArea: selectedFunctionalAreas.join(","),
    status: selectedStatus.join(","),
    brandCode: selectedBrand.join(","),
    searchedHltId: selectedUser,
    planSources: selectedPlanSources
  });

  useEffect(() => {
    dispatch(clearOpenSections());
  }, [dispatch]);

  useEffect(() => {
    if (status === "success" && !isAbovePropertyUser) {
      const props = {
        page: 0,
        size: PAGE_SIZE
      };

      dispatch(fetchMyPlansAsync(props));
    }
  }, [dispatch, status]);

  const getInputDetails = (input: string) => {
    if (input.length > 2 || !input) {
      setInputText(input);
    }
  };

  return (
    <>
      <Feedback form="addToMyPlans" message={messages.planAdded} />
      <Box marginTop={"32px"}>
        <Grid container display="flex" alignItems={"center"} justifyContent={"space-between"}>
          <Box></Box>
          <PageTitle label={isAdmin ? "Inncode Plans" : "My Plans"} />
          {!isAdmin && !isSmeUser && !isMobileScreen ? <CreateMyPlan /> : <Box></Box>}
        </Grid>
        <Grid container display="flex" alignItems={"center"}>
          {!isAbovePropertyUser && (
            <>
              <Grid item sm={3} xs={12}>
                <SearchAppBar
                  value={inputText}
                  getInputDetails={getInputDetails}
                  divider
                  planType={planTypes.MyPlans}
                ></SearchAppBar>
              </Grid>
              <Grid
                item
                sm={9}
                xs={12}
                flexWrap="wrap"
                display="flex"
                alignItems={"center"}
                sx={{
                  justifyContent: { xs: "space-between", md: "flex-end" },
                  marginTop: { xs: "10px" },
                  marginBottom: { xs: "10px" }
                }}
                marginLeft="auto"
              >
                <Filters filters={filters} setFilters={setFilters} />
              </Grid>
            </>
          )}
        </Grid>

        {inputText && (
          <Box marginLeft={"10px"} marginTop={"30px"} display="flex" flexDirection={"row"} gap="5px">
            <Typography variant={"body1"}>Showing search results for</Typography>
            <Typography variant={"body1"} showBold>
              "{inputText}"
            </Typography>
          </Box>
        )}
        <Grid marginTop={"30px"} container>
          {isAbovePropertyUser ? <AbovePropertyList /> : <List filters={filters} searchText={inputText} />}
        </Grid>
      </Box>
      {isMobileScreen && <CreateMyPlan />}
    </>
  );
};

export default Index;
